import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faChartLine } from '@fortawesome/pro-light-svg-icons/faChartLine'
import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons/faCircleQuestion'
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle'
import { faFileLines } from '@fortawesome/pro-light-svg-icons/faFileLines'
import { faGraduationCap } from '@fortawesome/pro-light-svg-icons/faGraduationCap'
import { faHandHoldingHeart } from '@fortawesome/pro-light-svg-icons/faHandHoldingHeart'
import { faHandHoldingUsd } from '@fortawesome/pro-light-svg-icons/faHandHoldingUsd'
import { faMinus } from '@fortawesome/pro-light-svg-icons/faMinus'
import { faMobile } from '@fortawesome/pro-light-svg-icons/faMobile'
import { faMoneyBillWave } from '@fortawesome/pro-light-svg-icons/faMoneyBillWave'
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus'
import { faPrint } from '@fortawesome/pro-light-svg-icons/faPrint'
import { faSearchDollar } from '@fortawesome/pro-light-svg-icons/faSearchDollar'
import { faStopwatch } from '@fortawesome/pro-light-svg-icons/faStopwatch'
import { faUserPlus } from '@fortawesome/pro-light-svg-icons/faUserPlus'
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle'
import { faExclamationTriangle as faExclamationTriangleSolid } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faFileLines as faFileLinesSolid } from '@fortawesome/pro-solid-svg-icons/faFileLines'
import { faGraduationCap as faGraduationCapSolid } from '@fortawesome/pro-solid-svg-icons/faGraduationCap'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faStopwatch as faStopwatchSolid } from '@fortawesome/pro-solid-svg-icons/faStopwatch'
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock'
import { faLockKeyhole } from '@fortawesome/pro-light-svg-icons/faLockKeyhole'
import { faWallet } from '@fortawesome/pro-light-svg-icons/faWallet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'

const icons = {
  stopWatch: faStopwatch,
  stopWatchSolid: faStopwatchSolid,
  chart: faChartLine,
  circleQuestionSolid: faCircleQuestion,
  clock: faClock,
  lock: faLockKeyhole,
  wallet: faWallet,
  alertTriangle: faExclamationTriangle,
  alertTriangleSolid: faExclamationTriangleSolid,
  alertCircle: faExclamationCircle,
  infoCircle: faInfoCircle,
  checkCircle: faCheckCircle,
  searchDollar: faSearchDollar,
  handHoldingUsd: faHandHoldingUsd,
  handHoldingHeart: faHandHoldingHeart,
  userPlus: faUserPlus,
  fileLinesSolid: faFileLinesSolid,
  fileLines: faFileLines,
  graduationCap: faGraduationCap,
  graduationCapSolid: faGraduationCapSolid,
  moneyBillWave: faMoneyBillWave,
  print: faPrint,
  mobile: faMobile,
  plus: faPlus,
  minus: faMinus,
  arrowUpRightFromSquare: faArrowUpRightFromSquare,
  chevronRight: faChevronRight,
}

export type IconNames = keyof typeof icons
export interface IconProps {
  /** if false, tab focus will ignore this icon. defaults to true */
  focusable?: boolean
  name: IconNames
  id: string
  width?: number
  height?: number
  color?: string
  easeIn?: boolean
  className?: string
  /** if false, the icon will be visible to screen readers. defaults to true */
  ariaHidden?: boolean
}

export const Icon = ({
  focusable = true,
  name,
  id,
  width = 24,
  height = 24,
  color = 'text-ink-600',
  className = '',
  easeIn = false,
  ariaHidden = true,
}: IconProps) => (
  <FontAwesomeIcon
    focusable={!ariaHidden && focusable}
    icon={icons[name] as IconDefinition}
    className={classNames(color, easeIn && 'duration-150 ease-in', className)}
    title={name}
    style={{ height, width }}
    titleId={id}
  />
)
